import { render, staticRenderFns } from "./SalidaTrasladoComponent.vue?vue&type=template&id=9decbf42&"
import script from "./SalidaTrasladoComponent.vue?vue&type=script&lang=js&"
export * from "./SalidaTrasladoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports